import {
  Typography,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Stack,
} from '@mui/material';
import { useRootStore } from '../../../../stores/rootStore';

const EDUCATION_METRICS_AU = [
  {
    groupMetricId: '104',
    metricId: '1087',
    displayName: 'Education: Pre School',
    definition:
      'The percentage of Pre School level achieved for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1088',
    displayName: 'Education: Primary School',
    definition:
      'The percentage of Primary School level achieved for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1089',
    displayName: 'Education: Secondary School',
    definition:
      'The percentage of Secondary School level achieved for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1090',
    displayName: 'Education: TAFE',
    definition:
      'The percentage of TAFE level achieved for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1091',
    displayName: 'Education: University',
    definition:
      'The percentage of University level achieved for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1092',
    displayName: 'Education: Other',
    definition:
      'The percentage of Other level achieved for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1093',
    displayName: 'Education: Not Stated',
    definition:
      'The percentage of education Not Stated for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
];

const QUALIFICATION_METRICS_AU = [
  {
    groupMetricId: '103',
    metricId: '1079',
    displayName: 'Qualification: Postgrad',
    definition:
      'The percentage of Postgrads achieved for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1080',
    displayName: 'Qualification: Graduate Diploma or Certificate ',
    definition:
      'The percentage of Graduate Diploma or Certificates achieved for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1081',
    displayName: 'Qualification: Bachelor',
    definition:
      'The percentage of Bachelors achieved for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1082',
    displayName: 'Qualification: Advanced Diploma or Diploma',
    definition:
      'The percentage of Advanced Diploma or Diplomas achieved for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1083',
    displayName: 'Qualification: Certificate',
    definition:
      'The percentage of Certificates achieved for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1084',
    displayName: 'Qualification: Not Stated',
    definition:
      'The percentage of qualifications Not Stated for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1085',
    displayName: 'Qualification: Inadequately Described',
    definition:
      'The percentage of qualifications Inadequately Described for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
];

const EDUCATION_METRICS_NZ = [
  {
    groupMetricId: '114',
    metricId: '1215',
    displayName: 'Education: No Qualification',
    definition:
      'The percentage of No Qualification level achieved for the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1403',
    displayName: 'Education: Level 1 certificate',
    definition:
      'The percentage of Level 1 certificate achieved for the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1404',
    displayName: 'Education: Level 2 certificate',
    definition:
      'The percentage of Level 2 certificate achieved for the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1405',
    displayName: 'Education: Level 3 certificate',
    definition:
      'The percentage of Level 3 certificate achieved for the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1406',
    displayName: 'Education: Level 4 certificate',
    definition:
      'The percentage of Level 4 certificate achieved for the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1407',
    displayName: 'Education: Level 5 diploma',
    definition:
      'The percentage of Level 5 diploma achieved for the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1408',
    displayName: 'Education: Level 6 diploma',
    definition:
      'The percentage of Level 6 diploma achieved for the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1409',
    displayName: 'Education: Bachelor degree and level 7 qualification',
    definition:
      'The percentage of Bachelor degree and level 7 qualification achieved for the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1410',
    displayName: 'Education: Masters Degree',
    definition:
      'The percentage of Masters Degree achieved for the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1411',
    displayName: 'Education: Doctorate degree',
    definition:
      'The percentage of Doctorate degree achieved for the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1412',
    displayName: 'Education: Overseas secondary school qualification',
    definition:
      'The percentage of Overseas secondary school qualification achieved for the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1413',
    displayName: 'Education: Post-graduate and honours degrees',
    definition:
      'The percentage of Post-graduate and honours degrees achieved for the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1414',
    displayName: 'Education: Not elsewhere included',
    definition:
      'The percentage of Not elsewhere included for the geographical area. This metric is available for 2023.',
  },
];

export const EducationMetrics = () => {
  const country = useRootStore(state => state.country);

  const metrics = [
    {
      title: 'Education',
      data: country === 'au' ? EDUCATION_METRICS_AU : EDUCATION_METRICS_NZ,
    },
    {
      title: 'Qualification',
      data: country === 'au' ? QUALIFICATION_METRICS_AU : [],
    },
  ];

  return (
    <div>
      <Typography id="education-metrics" variant="h6" fontWeight={600} my={0.5}>
        Education Metrics
      </Typography>

      <Typography variant="body2">
        The Education Metrics relate to the levels of Education achieved for a
        particular location.
      </Typography>

      <br />

      <Stack gap={4}>
        {metrics
          .filter(metric => metric.data.length > 0)
          .map(metric => (
            <div>
              <Typography variant="body2" fontWeight={600}>
                {metric.title}
              </Typography>

              <br />

              <TableContainer component={Paper}>
                <Table>
                  <TableHead sx={{ whiteSpace: 'nowrap' }}>
                    <TableRow>
                      <TableCell>Group Metric ID</TableCell>
                      <TableCell>Metric ID</TableCell>
                      <TableCell>Display Name</TableCell>
                      <TableCell>Definition</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {metric.data.map(data => (
                      <TableRow key={data.metricId}>
                        {data.groupMetricId && (
                          <TableCell rowSpan={metric.data.length}>
                            {data.groupMetricId}
                          </TableCell>
                        )}
                        <TableCell>{data.metricId}</TableCell>
                        <TableCell>{data.displayName}</TableCell>
                        <TableCell>{data.definition}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          ))}
      </Stack>
    </div>
  );
};
